<template>
  <div class="my_privacy_wrap">
    <!--start-->
    <div id="copyall" class="copyall">
      <h1>一、引言</h1>
      <p>本软件重视用户的隐私。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。</p>
      <p>您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。</p>
      <h1>二、我们可能收集您的信息</h1>
      <p>我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</p>
      <p><strong>您提供的信息</strong></p>
      <p>&middot;您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如电话号码、电子邮件或银行卡号等；</p>
      <p>&middot;您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。</p>
      <p><strong>其他方分享的您的信息</strong></p>
      <p>&middot;其他方使用我们的服务时所提供有关您的共享信息。</p>
      <p><strong>我们获取的您的信息</strong></p>
      <p>您使用服务时我们可能收集如下信息：</p>
      <p>&middot;日志信息，指您使用我们的服务时，系统可能通过cookies、web beacon或其他方式自动采集的技术信息，包括：</p>
      <p>&middot;设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址、移动设备所用的版本和ANDROID ID、IMEI、IMSI等；</p>
      <p>&middot;在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；</p>
      <p>&middot;有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；</p>
      <p>&middot;您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；</p>
      <p>&middot;您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。</p>
      <p>&middot;位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：</p>
      <p>&middot;您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；</p>
      <p>&middot;您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；</p>
      <p>&middot;您可以通过关闭定位功能，停止对您的地理位置信息的收集。</p>
      <h1>三、我们可能如何使用信息</h1>
      <p>我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：</p>
      <p>&middot;收集设备或软件信息是为了帮助我们进行bug分析，保障您正常使用我们产品和服务、改进和优化我们的产品体验、保障您的账号安全；</p>
      <p>&middot;在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；</p>
      <p>&middot;帮助我们设计新服务，改善我们现有服务；</p>
      <p>&middot;使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；</p>
      <p>&middot;向您提供与您更加相关的广告以替代普遍投放的广告；</p>
      <p>&middot;评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；</p>
      <p>&middot;软件认证或管理软件升级；</p>
      <p>&middot;让您参与有关我们产品和服务的调查。</p>
      <p>为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。</p>
      <h1>四、您如何访问和控制个人信息</h1>
      <p>我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。</p>
      <h1>五、我们可能分享的信息</h1>
      <p>除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：</p>
      <p>&middot;我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：</p>
      <p>&middot;向您提供我们的服务；</p>
      <p>&middot;实现“我们可能如何使用信息”部分所述目的；</p>
      <p>&middot;履行我们在本《隐私政策》中的义务和行使我们的权利；</p>
      <p>&middot;理解、维护和改善我们的服务。</p>
      <p>如我们或我们的关联公司与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。</p>
      <p>&middot;随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。</p>
      <p>&middot;我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：</p>
      <p>&middot;遵守适用的法律法规；</p>
      <p>&middot;遵守法院命令或其他法律程序的规定；</p>
      <p>&middot;遵守相关政府机关的要求；</p>
      <p>&middot;为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。</p>
      <h1>六、信息安全</h1>
      <p>我们仅在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。</p>
      <p>我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
      <h1>七、隐私范围的适用范围</h1>
      <p>除某些特定服务外，我们所有的服务均适用本《隐私政策》。这些特定服务将适用特定的隐私政策。针对某些特定服务的特定隐私政策，将更具体地说明我们在该等服务中如何使用您的信息。该特定服务的隐私政策构成本《隐私政策》的一部分。如相关特定服务的隐私政策与本《隐私政策》有不一致之处，适用该特定服务的隐私政策。</p>
      <h1>八、变更</h1>
      <p>我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分。如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。</p>
      <p>感谢您花时间阅读和理解我们的隐私政策！我们将尽全力保护您的个人信息和合法权益，再次感谢您的信任！</p>
      <h4>应用名称：日化标识码</h4>
      <h4>开发者名称：涿溪（广州）日化科技有限公司</h4>
      </div>
    <!--end-->




  </div>
</template>

<script>

export default {
  name: 'privacy',
  data() {
    return {

    };
  },
  components: {

  }
}
</script>
<style>
.my_privacy_wrap{
  width: 100%;
  height: 100%;
  /* border: 1px solid #f00; */
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 0.1rem;
}
.copyall{
  font-size: 0.12rem;
}
.copyall h1 {
  font-size: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Privacy.vue